import { NgModule } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MaterialModule } from 'src/material.module';
import { MatIconRegistry } from '@angular/material/icon';
@NgModule({
  imports: [MaterialModule],
})
export class MESvgIconsModule {
  private pathBrands: string = 'assets/svg-icons/brands';
  private pathDuotone: string = 'assets/svg-icons/duotone';
  private pathLight: string = 'assets/svg-icons/light';
  private pathRegular: string = 'assets/svg-icons/regular';
  private pathSolid: string = 'assets/svg-icons/solid';
  constructor(
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry
  ) {
    // prefix: fal: light; far: regular; fas: solid
    this.matIconRegistry
      .addSvgIcon('falBan', this.setPath(`${this.pathLight}/ban.svg`))
      .addSvgIcon('falBell', this.setPath(`${this.pathLight}/bell.svg`))
      .addSvgIcon('falBoxUsd', this.setPath(`${this.pathLight}/box-usd.svg`))
      .addSvgIcon('falCalendarDay', this.setPath(`${this.pathLight}/calendar-day.svg`))
      .addSvgIcon('falCheckCircle', this.setPath(`${this.pathLight}/check-circle.svg`))
      .addSvgIcon('falChevronDown', this.setPath(`${this.pathLight}/chevron-down.svg`))
      .addSvgIcon('falChevronLeft', this.setPath(`${this.pathLight}/chevron-left.svg`))
      .addSvgIcon('falChevronRight', this.setPath(`${this.pathLight}/chevron-right.svg`))
      .addSvgIcon('falChevronUp', this.setPath(`${this.pathLight}/chevron-up.svg`))
      .addSvgIcon('falCloseComment', this.setPath(`${this.pathLight}/comment-alt-slash.svg`))
      .addSvgIcon('falCog', this.setPath(`${this.pathLight}/cog.svg`))
      .addSvgIcon('falCommentAltSlash', this.setPath(`${this.pathLight}/comment-alt-slash.svg`))
      .addSvgIcon('falComments', this.setPath(`${this.pathLight}/comments.svg`))
      .addSvgIcon('falCreditCardFront', this.setPath(`${this.pathLight}/credit-card-front.svg`))
      .addSvgIcon('falCreditCard', this.setPath(`${this.pathLight}/credit-card.svg`))
      .addSvgIcon('falEdit', this.setPath(`${this.pathLight}/edit.svg`))
      .addSvgIcon('falEnvelopeOpenDollar', this.setPath(`${this.pathLight}/envelope-open-dollar.svg`))
      .addSvgIcon('falExclamationTriangle', this.setPath(`${this.pathLight}/exclamation-triangle.svg`))
      .addSvgIcon('falExternalLink', this.setPath(`${this.pathLight}/external-link.svg`))
      .addSvgIcon('falExternalLinkSquare', this.setPath(`${this.pathLight}/external-link-square.svg`))
      .addSvgIcon('falFileExport', this.setPath(`${this.pathLight}/file-export.svg`))
      .addSvgIcon('falFilePdf', this.setPath(`${this.pathLight}/file-pdf.svg`))
      .addSvgIcon('falFilter', this.setPath(`${this.pathLight}/filter.svg`))      
      .addSvgIcon('falGlobe', this.setPath(`${this.pathLight}/globe.svg`))
      .addSvgIcon('falHandHoldingUsd', this.setPath(`${this.pathLight}/hand-holding-usd.svg`))
      .addSvgIcon('falInfo', this.setPath(`${this.pathLight}/info.svg`))
      .addSvgIcon('falInfoCircle', this.setPath(`${this.pathLight}/info-circle.svg`))
      .addSvgIcon('falLightbulbOn', this.setPath(`${this.pathLight}/lightbulb-on.svg`))
      .addSvgIcon('falMinus', this.setPath(`${this.pathLight}/minus.svg`))
      .addSvgIcon('falMoneyBillAlt', this.setPath(`${this.pathLight}/money-bill-alt.svg`))
      .addSvgIcon('falMoneyCheckEditAlt', this.setPath(`${this.pathLight}/money-check-edit-alt.svg`))
      .addSvgIcon('falPaperPlane', this.setPath(`${this.pathLight}/paper-plane.svg`))
      .addSvgIcon('falPencilAlt', this.setPath(`${this.pathLight}/pencil-alt.svg`))
      .addSvgIcon('falPlusCircle', this.setPath(`${this.pathLight}/plus-circle.svg`))
      .addSvgIcon('falPlus', this.setPath(`${this.pathLight}/plus.svg`))
      .addSvgIcon('falPowerOff', this.setPath(`${this.pathLight}/power-off.svg`))
      .addSvgIcon('falRetweet', this.setPath(`${this.pathLight}/retweet.svg`))
      .addSvgIcon('falSearch', this.setPath(`${this.pathLight}/search.svg`))
      .addSvgIcon('falSync', this.setPath(`${this.pathLight}/sync.svg`))
      .addSvgIcon('falThList', this.setPath(`${this.pathLight}/th-list.svg`))
      .addSvgIcon('falTimes', this.setPath(`${this.pathLight}/times.svg`))
      .addSvgIcon('falTimesCircle', this.setPath(`${this.pathLight}/times-circle.svg`))
      .addSvgIcon('falTrashAlt', this.setPath(`${this.pathLight}/trash-alt.svg`))
      .addSvgIcon('falUpload', this.setPath(`${this.pathLight}/upload.svg`))
      .addSvgIcon('falUsdCircle', this.setPath(`${this.pathLight}/usd-circle.svg`))
      .addSvgIcon('falCircleUserCircleCheck', this.setPath(`${this.pathLight}/circle-user-circle-check.svg`))
      .addSvgIcon('falUserCheck', this.setPath(`${this.pathLight}/user-check.svg`))
      .addSvgIcon('falUsers', this.setPath(`${this.pathLight}/users.svg`))
      .addSvgIcon('falWindowRestore', this.setPath(`${this.pathLight}/window-restore.svg`))      

      .addSvgIcon('farAngleDoubleLeft', this.setPath(`${this.pathRegular}/angle-double-left.svg`))
      .addSvgIcon('farBan', this.setPath(`${this.pathRegular}/ban.svg`))
      .addSvgIcon('farBars', this.setPath(`${this.pathRegular}/bars.svg`))
      .addSvgIcon('farCheck', this.setPath(`${this.pathRegular}/check.svg`))
      .addSvgIcon('farCheckCircle', this.setPath(`${this.pathRegular}/check-circle.svg`))
      .addSvgIcon('farChevronDown', this.setPath(`${this.pathRegular}/chevron-down.svg`))
      .addSvgIcon('farCommentAltSlash', this.setPath(`${this.pathRegular}/comment-alt-slash.svg`))
      .addSvgIcon('farCommentsAlt', this.setPath(`${this.pathRegular}/comments-alt.svg`))
      .addSvgIcon('farDownload', this.setPath(`${this.pathRegular}/download.svg`))
      .addSvgIcon('farEnvelope', this.setPath(`${this.pathRegular}/envelope.svg`))
      .addSvgIcon('farEnvelopeOpenDollar', this.setPath(`${this.pathRegular}/envelope-open-dollar.svg`))
      .addSvgIcon('farEraser', this.setPath(`${this.pathRegular}/eraser.svg`))
      .addSvgIcon('farExternalLink', this.setPath(`${this.pathRegular}/external-link.svg`))
      .addSvgIcon('farEye', this.setPath(`${this.pathRegular}/eye.svg`))
      .addSvgIcon('farEyeSlash', this.setPath(`${this.pathRegular}/eye-slash.svg`))
      .addSvgIcon('farImagePolaroid', this.setPath(`${this.pathRegular}/image-polaroid.svg`))
      .addSvgIcon('farMapMarkedAlt', this.setPath(`${this.pathRegular}/map-marked-alt.svg`))
      .addSvgIcon('farMapMarkerAlt', this.setPath(`${this.pathRegular}/map-marker-alt.svg`))
      .addSvgIcon('farMicrophone', this.setPath(`${this.pathRegular}/microphone.svg`))
      .addSvgIcon('farMicrophoneCircle', this.setPath(`${this.pathRegular}/microphone-circle.svg`))
      .addSvgIcon('farMinus', this.setPath(`${this.pathRegular}/minus.svg`))
      .addSvgIcon('farMoneyBillAlt', this.setPath(`${this.pathRegular}/money-bill-alt.svg`))
      .addSvgIcon('farMoneyCheckEditAlt', this.setPath(`${this.pathRegular}/money-check-edit-alt.svg`))
      .addSvgIcon('farPaperPlane', this.setPath(`${this.pathRegular}/paper-plane.svg`))
      .addSvgIcon('farPhoneAlt', this.setPath(`${this.pathRegular}/phone-alt.svg`))
      .addSvgIcon('farPlus', this.setPath(`${this.pathRegular}/plus.svg`))
      .addSvgIcon('farQRCode', this.setPath(`${this.pathRegular}/qrcode.svg`))
      .addSvgIcon('farRedo', this.setPath(`${this.pathRegular}/redo.svg`))
      .addSvgIcon('farSignIn', this.setPath(`${this.pathRegular}/sign-in.svg`))
      .addSvgIcon('farSignOut', this.setPath(`${this.pathRegular}/sign-out.svg`))
      .addSvgIcon('farTimesCircle', this.setPath(`${this.pathRegular}/times-circle.svg`))
      .addSvgIcon('farToggleOff', this.setPath(`${this.pathRegular}/toggle-off.svg`))
      .addSvgIcon('farToggleOn', this.setPath(`${this.pathRegular}/toggle-on.svg`))
      .addSvgIcon('farUndo', this.setPath(`${this.pathRegular}/undo.svg`))
      .addSvgIcon('farUndoAlt', this.setPath(`${this.pathRegular}/undo-alt.svg`))
      .addSvgIcon('farUserPlus', this.setPath(`${this.pathRegular}/user-plus.svg`))
      .addSvgIcon('farVideo', this.setPath(`${this.pathRegular}/video.svg`))

      .addSvgIcon('fasArrowAltToBottom', this.setPath(`${this.pathSolid}/arrow-alt-to-bottom.svg`))
      .addSvgIcon('fasArrowAltToLeft', this.setPath(`${this.pathSolid}/arrow-alt-to-left.svg`))
      .addSvgIcon('fasArrowAltToRight', this.setPath(`${this.pathSolid}/arrow-alt-to-right.svg`))
      .addSvgIcon('fasBellSlash', this.setPath(`${this.pathSolid}/bell-slash.svg`))
      .addSvgIcon('fasBell', this.setPath(`${this.pathSolid}/bell.svg`))
      .addSvgIcon('fasCog', this.setPath(`${this.pathSolid}/cog.svg`))
      .addSvgIcon('fasInfoCircle', this.setPath(`${this.pathSolid}/info-circle.svg`))
      .addSvgIcon('fasMapMarkerAlt', this.setPath(`${this.pathSolid}/map-marker-alt.svg`))
      .addSvgIcon('fasMicrophone', this.setPath(`${this.pathSolid}/microphone.svg`))
      .addSvgIcon('fasMicrophoneCircle', this.setPath(`${this.pathSolid}/microphone-circle.svg`))
      .addSvgIcon('fasPaperclip', this.setPath(`${this.pathSolid}/paperclip.svg`))
      .addSvgIcon('fasPhoneAlt', this.setPath(`${this.pathSolid}/phone-alt.svg`))
      .addSvgIcon('fasToggleOff', this.setPath(`${this.pathSolid}/toggle-off.svg`))
      .addSvgIcon('fasToggleOn', this.setPath(`${this.pathSolid}/toggle-on.svg`))
      .addSvgIcon('fasUserFriends', this.setPath(`${this.pathSolid}/user-friends.svg`));
  }
  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
